import { render, staticRenderFns } from "./TaskCommentTreeNode.vue?vue&type=template&id=7971ee80&"
import script from "./TaskCommentTreeNode.vue?vue&type=script&lang=js&"
export * from "./TaskCommentTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7971ee80')) {
      api.createRecord('7971ee80', component.options)
    } else {
      api.reload('7971ee80', component.options)
    }
    module.hot.accept("./TaskCommentTreeNode.vue?vue&type=template&id=7971ee80&", function () {
      api.rerender('7971ee80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskCommentTreeNode.vue"
export default component.exports